/**
 * Format a UZS amount (stored as bigint tiyin or string in JSON) for display.
 * `5000000000` tiyin → "5 000 000 сум" (ru) / "5 000 000 UZS" (en).
 */
export function formatUzs(
  amount: bigint | string | number,
  locale: 'ru' | 'uz' | 'en' = 'ru',
): string {
  const big = typeof amount === 'bigint' ? amount : BigInt(String(amount));
  const negative = big < 0n;
  const abs = negative ? -big : big;
  const whole = abs / 100n;
  const frac = abs % 100n;
  const wholeStr = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const suffix = locale === 'en' ? ' UZS' : ' сум';
  const fracPart = frac > 0n ? `,${frac.toString().padStart(2, '0')}` : '';
  return `${negative ? '-' : ''}${wholeStr}${fracPart}${suffix}`;
}

export function formatUzsCompact(amount: bigint | string | number): string {
  const big = typeof amount === 'bigint' ? amount : BigInt(String(amount));
  const uzs = big / 100n;
  if (uzs >= 1_000_000_000n) return `${(Number(uzs) / 1e9).toFixed(2)} млрд`;
  if (uzs >= 1_000_000n) return `${(Number(uzs) / 1e6).toFixed(1)} млн`;
  if (uzs >= 1_000n) return `${(Number(uzs) / 1e3).toFixed(0)} тыс`;
  return uzs.toString();
}

/** Convert a tiyin amount (bigint/string) to whole soʻm as a JS number — for charts. */
export function tiyinToSom(amount: bigint | string | number): number {
  const big = typeof amount === 'bigint' ? amount : BigInt(String(amount));
  return Number(big / 100n);
}

export function pricePerSqm(basePrice: bigint | string, areaSqm: number | string): string {
  const big = typeof basePrice === 'bigint' ? basePrice : BigInt(String(basePrice));
  const area = Number(areaSqm);
  if (area <= 0) return '—';
  const perSqm = big / BigInt(Math.round(area * 100)) * 100n;
  return formatUzs(perSqm) + '/м²';
}
